import { render, staticRenderFns } from "./index3.vue?vue&type=template&id=687e91a5&scoped=true"
import script from "./index3.vue?vue&type=script&lang=js"
export * from "./index3.vue?vue&type=script&lang=js"
import style0 from "./index3.vue?vue&type=style&index=0&id=687e91a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687e91a5",
  null
  
)

export default component.exports